import "./AboutYou.scss"

import {
  ABOUT_YOU_FEMALE_LABEL,
  ABOUT_YOU_MALE_LABEL,
  ABOUT_YOU_MANY_LABEL,
  FIRST_NAME_PLACEHOLDER,
  LAST_NAME_PLACEHOLDER,
  PREFERRED_NOUNS_LABEL,
} from "../../constants/messages"
import { Input } from "../../atoms"
import { Col, Form, Row } from "antd"
import React, { useState } from "react"
import { getUserData, savePreferences } from "../../redux/actionCreators/auth"

import { AboutYouValidation } from "../../validationSchema/AboutYouValidation"
import { GENDERS } from "../../constants/commons"
import UploadAvatar from "../UploadAvatar/UploadAvatar"
import _ from "../../utils/lodashUtils"
import avatarRing from "../../assets/images/avatar-ring.svg"
import { connect } from "react-redux"
import moment from "moment"
import { withFormik } from "formik"
import { withRouter } from "react-router-dom"

const S = (props) => {
  const {
    values,
    handleSubmit,
    handleChange,
    handleBlur,
    touched,
    errors,
    isSubmitting,
    isValid,
    getUserData,
  } = props

  let defaultValue = _.get(props.user, "gender")
    ? _.get(props.user, "gender")
    : "MANY"

  const [gender, setGender] = useState(defaultValue)

  const onChangeValue = (event) => {
    values.pronoun = event.target.value
    //write radio gender selection function call here
    asyncSaveEachValue()
  }

  const setGenderFunc = (event) => {
    setGender(event.currentTarget.value)
  }

  const asyncSaveEachValue = () => {
    //save the data to backend when field is out of focus
    if (!errors.displayName) {
      if (!values.pronoun) values.pronoun = defaultValue
      props.savePreferences(
        { ...values, dateOfBirth: "" },
        props.user.id,
        false
      )
    }
  }

  const [roboName, setRoboName] = useState(values.displayName)

  const handleRoboName = () => {
    //get robo pic when display name changes
    setRoboName(values.displayName)
    asyncSaveEachValue()
  }

  return (
    <div id="AboutYou">
      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="formContent">
          <div className="inputFieldsContainer">
            <div className="avatar">
              <img className="ovalBg" src={avatarRing} alt="backgroud circle" />
              <UploadAvatar roboName={roboName} />
            </div>
            <div className="profileNameInfo">
              <Form.Item
                onBlur={handleBlur}
                validateStatus={
                  touched.displayName && errors.displayName
                    ? "error"
                    : undefined
                }
              >
                <Input
                  name="displayName"
                  value={values.displayName}
                  onChange={handleChange}
                  onBlur={handleRoboName}
                  placeholder={FIRST_NAME_PLACEHOLDER}
                  maxLength="15"
                  error={
                    touched.displayName && errors.displayName
                      ? errors.displayName
                      : ""
                  }
                />
              </Form.Item>
              <div className="lastName">
                <Form.Item>
                  <Input
                    name="lastName"
                    value={values.lastName}
                    onChange={handleChange}
                    onBlur={asyncSaveEachValue}
                    placeholder={LAST_NAME_PLACEHOLDER}
                  />
                </Form.Item>
              </div>
            </div>
          </div>
          <div className="preferredContainer">
            <Row>
              <div className="Preferred">{PREFERRED_NOUNS_LABEL}*</div>
              <Col span={24} id="preferenceSelect">
                <div>
                  <div className="greenclass2">
                    <Form.Item onChange={handleChange} onBlur={handleBlur}>
                      <div onChange={onChangeValue}>
                        <div className="radio-item">
                          <input
                            id="femaleRadio"
                            type="radio"
                            value={GENDERS.FEMALE}
                            name="gender"
                            checked={gender === "FEMALE"}
                            onChange={setGenderFunc}
                          />
                          <label htmlFor="femaleRadio">
                            {ABOUT_YOU_FEMALE_LABEL}
                          </label>
                        </div>
                        <div className="radio-item">
                          <input
                            id="maleRadio"
                            type="radio"
                            value={GENDERS.MALE}
                            name="gender"
                            checked={gender === "MALE"}
                            onChange={setGenderFunc}
                          />
                          <label htmlFor="maleRadio">
                            {ABOUT_YOU_MALE_LABEL}
                          </label>
                        </div>
                        <div className="radio-item">
                          <input
                            id="manyRadio"
                            type="radio"
                            value={GENDERS.MANY}
                            name="gender"
                            checked={gender === "MANY"}
                            onChange={setGenderFunc}
                          />
                          <label htmlFor="manyRadio">
                            {ABOUT_YOU_MANY_LABEL}
                          </label>
                        </div>
                      </div>
                    </Form.Item>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          {/* Commenting date picker, need to modify this later */}
          {/* <div className="datePickerContainer">
            <Col span={24} id="datePicker">
              <div className="DOB">{ABOUT_YOU_DATE_OF_BIRTH_LABEL}</div>
              <Row>
                <Field
                  value={values.dateOfBirth}
                  component={AntDatePicker}
                  picker="date"
                  //disable future dates
                  disabledDate={(dateValue) => {
                    return (
                      !dateValue ||
                      dateValue?.isAfter(moment().utc().format("YYYY-MM-DD"))
                    )
                  }}
                  format="DD-MM-YYYY"
                  name="dateOfBirth"
                  bordered={false}
                />
              </Row>
            </Col>
          </div> */}
        </div>
      </form>
    </div>
  )
}
const AboutYou = withFormik({
  enableReinitialize: true,
  validateOnMount: true,
  mapPropsToValues: (props) => ({
    displayName: _.get(props, "user.display_name", ""),
    lastName: _.get(props, "user.last_name", ""),
    dateOfBirth:
      props.user && props.user.dob ? moment(props.user.dob, "YYYY-MM-DD") : "",
    pronoun: _.get(props, "pronoun"),
  }),
  handleSubmit: async (values, { props, setErrors }) => {
    values.pronoun = values.pronoun
      ? values.pronoun
      : _.get(props.user, "gender", "MANY")
    // const dob = moment(values.dateOfBirth).format("YYYY-MM-DD")
    props.savePreferences({ ...values, dateOfBirth: "" }, props.user.id, true)
  },
  validationSchema: AboutYouValidation,
})(S)

const mapStateToProps = (state) => ({
  user: state.auth.user,
})

export default connect(mapStateToProps, {
  savePreferences,
  getUserData,
})(withRouter(AboutYou))
